export default __webpack_public_path__ + "static/media/routeWhite.fd402739.svg";